import { useIsKinderConnectCaptureEnabledForChildren, } from './use-is-kinder-connect-capture-enabled-for-children';
/**
 * Single-child convenience wrapper around {@link useIsKinderConnectCaptureEnabledForChildren} for
 * the many call sites that only ever deal with one child (a single-child check-in/check-out, or a
 * detail view scoped to one child).
 *
 * @param childId - The child the check-in/check-out or detail view is scoped to.
 * @param siteId - The site the check-in/check-out is happening at, used only as a fallback if the
 * per-child answer errors. Pass an empty string if unavailable -- the fallback is then skipped.
 * @returns Whether KinderConnect capture is enabled for the current user for this child, and
 * whether that answer is still pending -- see `isLoading` on {@link KinderConnectCaptureForChildren}.
 */
export const useIsKinderConnectCaptureEnabledForChild = (childId, siteId) => useIsKinderConnectCaptureEnabledForChildren([childId], siteId);
